import {
    legacy_createStore as createStore,
    combineReducers,
    compose,
    applyMiddleware,
} from "redux";

import thunk, { ThunkDispatch } from "redux-thunk";
import logger from "redux-logger";
import { isLoadingState } from "./common/isLoading/state";
import { LoadingAction } from "./common/isLoading/action";
import { isLoadingReducer } from "./common/isLoading/reducer";
import { userRoleState } from "./userRoleList/state";
import { UserRoleAction } from "./userRoleList/action";
import { userRoleReducer } from "./userRoleList/reducer";
import { UserAuthState } from "./auth/state";
import { UserAuthReducer } from "./auth/reducer";
import { SnackBarState } from "./common/snackBar/state";
import { UserAuthAction } from "./auth/action";
import { SnackBarOpenReducer } from "./common/snackBar/reducer";
import { NavBarState } from "./common/navBar/state";
import { NavBarStateReducer } from "./common/navBar/reducer";
import { StaticInfoState } from "./staticInfo/state";
import { StaticInfoAction } from "./staticInfo/action";
import { StaticInfoReducer } from "./staticInfo/reducer";
import { EnquiryFormInfoState } from "./EnquiryForm/state";
import { EnquiryFormInfoAction } from "./EnquiryForm/action";
import { EnquiryFormInfoReducer } from "./EnquiryForm/reducer";
import { UserFormState } from "./user/state";
import { UserFormAction } from "./user/action";
import { UserFormReducer } from "./user/reducer";
import { InspectionState } from "./inspection/state";
import { InspectionAction } from "./inspection/action";
import { InspectionReducer } from "./inspection/reducer";
import { BinListReducer } from "./BinType/reducer";
import { RouteState } from "./route/state";
import { RouteAction } from "./route/action";
import { RouteReducer } from "./route/reducer";
import { CollectionState } from "./collection/state";
import { CollectionAction } from "./collection/action";
import { CollectionReducer } from "./collection/reducer";
import { NFCState } from "./nfc/state";
import { NfcAction } from "./nfc/action";
import { NFCReducer } from "./nfc/reducer";
import { CleaningState } from "./cleaning/state";
import { CleaningAction } from "./cleaning/action";
import { cleaningReducer } from "./cleaning/reducer";
import { CleaningRouteState } from "./cleaningRoute/state";
import { CleaningRouteAction } from "./cleaningRoute/action";
import { CleaningRouteReducer } from "./cleaningRoute/reducer";
import { BinListState } from "./BinType/state";
import { BinListAction } from "./BinType/action";
import { BinGroupInterface } from "./BinGroup/state";
import { BinGroupListAction } from "./BinGroup/action";
import { BinGroupReducer } from "./BinGroup/reducer";
import { ContractAction } from "./contract/action";
import { ContractReducer } from "./contract/reducer";
import { ContractInterface } from "./contract/state";
import { PeopleCounterState } from "./peopleCounter/state";
import { PeopleCounterAction } from "./peopleCounter/action";
import { PeopleCounterReducer } from "./peopleCounter/reducer";

declare global {
    /* tslint:disable:interface-name */
    interface Window {
        __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: any;
    }
}

export interface IRootState {
    isLoading: isLoadingState;
    userRoleList: userRoleState;
    userAuth:UserAuthState
    initSnackBardState: SnackBarState;
    initNavBarState:NavBarState
    staticInfoState:StaticInfoState
    enquiryFormInfoState:EnquiryFormInfoState
    userFormState:UserFormState
    inspectionState:InspectionState
    binListState: BinListState
    routeState:RouteState,
    collectionState:CollectionState,
    nfcState:NFCState
    cleaningState:CleaningState
    cleaningRouteState:CleaningRouteState
    binGroupListState:BinGroupInterface
    contractState:ContractInterface
    peopleCounterState:PeopleCounterState
}

type IRootAction = 
|LoadingAction 
| UserRoleAction
| UserAuthAction
| StaticInfoAction
| EnquiryFormInfoAction
| UserFormAction
| InspectionAction
| BinListAction
| RouteAction
| CollectionAction
| NfcAction
| CleaningAction
| CleaningRouteAction
|  BinGroupListAction
| ContractAction
| PeopleCounterAction

const rootReducer = combineReducers<IRootState>({
    isLoading: isLoadingReducer,
    userRoleList: userRoleReducer,
    userAuth:UserAuthReducer,
    initSnackBardState:SnackBarOpenReducer,
    initNavBarState:NavBarStateReducer,
    staticInfoState:StaticInfoReducer,
    enquiryFormInfoState:EnquiryFormInfoReducer,
    userFormState:UserFormReducer,
    inspectionState:InspectionReducer,
    binListState:BinListReducer,
    routeState:RouteReducer,
    collectionState:CollectionReducer,
    nfcState:NFCReducer,
    cleaningState:cleaningReducer,
    cleaningRouteState:CleaningRouteReducer,
    binGroupListState:BinGroupReducer,
    contractState:ContractReducer,
    peopleCounterState:PeopleCounterReducer,
});

export type IRootThunkDispatch = ThunkDispatch<IRootState, null, IRootAction>;

const enhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(
    rootReducer,
    enhancer(applyMiddleware(logger), applyMiddleware(thunk))
);
